import React from 'react';
import PropTypes from 'prop-types';
import UniversalCamViewer from '../../../../components/UniversalCamViewer';

const LiveCameraViewer = ({ buildingId, door }) => {
  const camera = door?.cameras?.[0];

  return (
    <div className="camara-viewer">
      {camera && (
        <div className="canvas-container">
          <span>{camera.name}</span>
          <UniversalCamViewer
            buildingId={buildingId}
            camId={camera.id}
            webrtcUrl={camera.webrtcUrl}
            className="cam-canvas"
          />
        </div>
      )}
    </div>
  );
};

LiveCameraViewer.propTypes = {
  buildingId: PropTypes.string,
  door: PropTypes.object,
};

export default LiveCameraViewer;
